import React from "react"
import { AppBasicTable, AppResultsSkeleton, NoDataFound } from "@components"
import { useInfoBlockData } from "Pages/BusinessLogistics/Analytics/Page/@hooks"
import { labelColumn, searchesColumn } from "Pages/BusinessLogistics/Analytics/Page/@components/Table/@columns"
import { dsColorNew } from "@palette"


export default function EuropcarTable({ label, requestType }) {

	const { res, isLoading } = useInfoBlockData(requestType, true)

	if (isLoading) return <AppResultsSkeleton rows={7} columns={2}/>

	if (!res?.length) return <NoDataFound/>

	return <AppBasicTable
		toolbarProps={{ actions: false }}
		titleProps={{ actions: false }}
		sx={{ height: 313 }}
		data={res}
		setHeaderCellProps={(_, idx) => ({
			sx: {
				backgroundColor: dsColorNew.tableHead,
				textAlign: !idx && "left !important"
			}
		})}
		headers={[[
			{ label: label },
			{ label: 'Searches' },
		]]}
		columns={[labelColumn(label), searchesColumn()]}/>

}